import { createElement, ComponentType, FunctionComponent, useContext } from "react";
import { StyleContext } from "@core-ui/contexts/StyleContext";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withStyles<T extends object = {}>(component: ComponentType<T>, ...styles: any[]): FunctionComponent<T> {
    return function WithStylesConsumer(props: T): ReturnType<FunctionComponent<T>> {
        if (typeof window === "undefined" && typeof document === "undefined") {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useContext(StyleContext).addStyles(styles);
        }

        return createElement(component, props);
    };
}
